import { COLORS } from "../../utils/js/constants";

export default function formFieldStyles(theme) {
  return {
    baseInput: {
      "& .MuiFormLabel-root, .MuiTypography-root, .MuiInputBase-input": {
        color: "white",
      },
      "& .MuiFormHelperText-root.Mui-error": {
        color: COLORS.lightYellow
      }
    },
  }
}
